// src/lib/functions.ts
export type DomainCode = "GV" | "ID" | "PR" | "DE" | "RS" | "RC";
export type HrvDomainCode = "OG" | "OC" | "SC" | "DS";
export type AnyDomainCode = DomainCode | HrvDomainCode;

export const DOMAIN_ORDER: DomainCode[] = ["GV", "ID", "PR", "DE", "RS", "RC"];
export const HRV_DOMAIN_ORDER: HrvDomainCode[] = ["OG", "OC", "SC", "DS"];

export const DOMAIN_LABELS: Record<DomainCode, string> = {
  GV: "Govern",
  ID: "Identify",
  PR: "Protect",
  DE: "Detect",
  RS: "Respond",
  RC: "Recover",
};

export const HRV_DOMAIN_LABELS: Record<HrvDomainCode, string> = {
  OG: "Ownership & Governance",
  OC: "Operational Control",
  SC: "Supply Chain & Technology",
  DS: "Data & Workload Sensitivity",
};

// Pre-Investment Triage modules
export const TRIAGE_DOMAIN_LABELS: Record<string, string> = {
  PROFILE: "Profile",
  M1: "Business & Market Exposure",
  M2: "Regulatory & Jurisdictional Exposure",
  M3: "Network & Infrastructure Footprint",
  M4: "Data Sensitivity & Volume Exposure",
  M5: "Third-Party & Supply Chain Exposure",
  M6: "Operational Complexity",
  M7: "Identity & Access Surface",
  M8: "Digital Revenue Dependence",
  M9: "External Risk Signals",
  M10: "Operational Recovery Complexity",
  RED_FLAG: "Red Flags",
};

export const TRIAGE_DOMAIN_ORDER = [
  "PROFILE", "M1", "M2", "M3", "M4", "M5", "M6", "M7", "M8", "M9", "M10", "RED_FLAG",
];

export const ALL_DOMAIN_LABELS: Record<string, string> = {
  ...DOMAIN_LABELS,
  ...HRV_DOMAIN_LABELS,
  ...TRIAGE_DOMAIN_LABELS,
};

export const DOMAIN_COLORS: Record<DomainCode, string> = {
  GV: "bg-violet-700 text-white",
  ID: "bg-sky-600 text-white",
  PR: "bg-emerald-600 text-white",
  DE: "bg-amber-600 text-white",
  RS: "bg-rose-600 text-white",
  RC: "bg-indigo-600 text-white",
};

export const HRV_DOMAIN_COLORS: Record<HrvDomainCode, string> = {
  OG: "bg-slate-700 text-white",
  OC: "bg-teal-600 text-white",
  SC: "bg-orange-600 text-white",
  DS: "bg-purple-600 text-white",
};

export const ALL_DOMAIN_COLORS: Record<string, string> = {
  ...DOMAIN_COLORS,
  ...HRV_DOMAIN_COLORS,
};
